import { RectNode, RectNodeModel, h } from '@logicflow/core';
import { renderMarkers } from './markers';
import { renderWrappedText } from './textUtils';
import { getThemeStyle } from '../theme';

class ScriptTaskView extends RectNode {
  getShape() {
    const { model } = this.props;
    const { x, y, width, height, radius } = model;
    const style = model.getNodeStyle();
    const props = model.properties || {};

    // Script icon position (top-left corner)
    const ix = x - width / 2 + 6;
    const iy = y - height / 2 + 4;

    const children = [
      h('rect', {
        x: x - width / 2,
        y: y - height / 2,
        width,
        height,
        rx: radius,
        ry: radius,
        ...style,
      }),
      // BPMN Script icon (document with wavy lines)
      h('path', {
        d: `M ${ix + 2} ${iy} C ${ix + 5} ${iy + 2} ${ix + 9} ${iy - 2} ${ix + 12} ${iy}
            L ${ix + 12} ${iy + 14}
            C ${ix + 9} ${iy + 12} ${ix + 5} ${iy + 16} ${ix + 2} ${iy + 14} Z`,
        fill: 'none',
        stroke: style.stroke,
        strokeWidth: 1.2,
      }),
      // Script lines
      h('line', { x1: ix + 5, y1: iy + 4, x2: ix + 10, y2: iy + 4, stroke: style.stroke, strokeWidth: 0.8 }),
      h('line', { x1: ix + 5, y1: iy + 7, x2: ix + 10, y2: iy + 7, stroke: style.stroke, strokeWidth: 0.8 }),
      h('line', { x1: ix + 5, y1: iy + 10, x2: ix + 10, y2: iy + 10, stroke: style.stroke, strokeWidth: 0.8 }),
    ];

    const label = (props && props.name) || '';
    if (label) {
      children.push(renderWrappedText(h, label, x, y + 4, width - 20, { graphModel: model.graphModel }));
    }

    children.push(...renderMarkers(x, y, width, height, props, style.stroke));

    return h('g', {}, children);
  }
}

class ScriptTaskModel extends RectNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.width = 120;
    this.height = 60;
    this.radius = 5;
    this.text = { ...this.text, editable: false, draggable: false, value: '' };
  }


  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'scriptTask');
    style.stroke = t.stroke || '#fa8c16';
    style.strokeWidth = t.strokeWidth ?? 1;
    style.fill = t.fill || '#fff7e6';
    return style;
  }
}

export const ScriptTask = {
  type: 'epx:ScriptTask',
  view: ScriptTaskView,
  model: ScriptTaskModel,
};
